import { Directive, input, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[spaSlot]',
  standalone: true,
})
export class SlotDirective {
  template = inject<TemplateRef<unknown>>(TemplateRef);

  spaSlot = input.required<string>();
}
